import React, { useEffect, useRef, useState } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

// Counts up from the previous value to `value` (ease-out), then renders it through `format`.
export default function AnimatedNumber({ value, format = (n) => n.toLocaleString('fr-FR'), duration = 900 }) {
  const target = Number(value) || 0;
  const [display, setDisplay] = useState(prefersReducedMotion() ? target : 0);
  const fromRef = useRef(display);

  useEffect(() => {
    if (prefersReducedMotion()) { setDisplay(target); return undefined; }
    const from = fromRef.current;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const current = from + (target - from) * eased;
      fromRef.current = current;
      setDisplay(current);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    // rAF is paused in background tabs: make sure the final value always lands
    const settle = setTimeout(() => { fromRef.current = target; setDisplay(target); }, duration + 80);
    return () => { cancelAnimationFrame(raf); clearTimeout(settle); };
  }, [target, duration]);

  return <>{format(Math.round(display))}</>;
}
